<template>
  <MessageLayout :is-archived="isArchived" :message="message">
    <h6 slot="header" class="message__title">
      Votre ticket du {{ message.date_for_display }} est
      <span :style="{ color: paletteFidmarques.green }">
        validé
      </span>
    </h6>

    <MessageBenefitsSummary
      slot="content"
      class="message__body"
      :points-count="message.data.earned_points_count"
      :collector-pieces-count="message.data.earned_collector_pieces_count"
      :coupons-count="message.data.used_coupons_count"
      :pot-increment="message.data.pot_increment"
      receipt-validated
    />

    <!-- eslint-disable vue/no-v-html -->
    <div v-if="message.data.text" slot="footer" v-html="nl2br(message.data.text)" />
    <!-- eslint-enable vue/no-v-html -->
  </MessageLayout>
</template>

<script>
import Mixin from './mixin'

import MessageBenefitsSummary from '../MessageBenefitsSummary'

export default {
  components: { MessageBenefitsSummary },
  mixins: [Mixin],
  props: {
    message: {
      type: Object,
      required: true,
      validator: message =>
        message.hasOwnProperty('date_for_display') &&
        message.hasOwnProperty('data') &&
        // message.data.hasOwnProperty('text') && // it can be present but not always
        message.data.hasOwnProperty('earned_points_count') &&
        message.data.hasOwnProperty('earned_collector_pieces_count') &&
        message.data.hasOwnProperty('used_coupons_count') &&
        message.data.hasOwnProperty('pot_increment') &&
        true
      ,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~assets/css/mixins";
@import "~assets/css/variables";

.message__title {
  @include font-family__oswald;
  margin: 0;
}
.message__body {
  padding: 1rem;
  background-color: $color-border-gray-ul;
}
</style>
